import { Button, Separator } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

import Accordion from './Accordion'

export const LayoutContainer = styled.div`
  padding-top: 80px;
  background: linear-gradient(#e5ecee 635px, white 635px);

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-top: 40px;
    background: linear-gradient(#e5ecee 513px, white 513px);
  }
`

const GetStartedButton = styled(Button)`
  margin: 20px auto 0;
  min-width: 220px;
`

export const TopGetStartedButton = styled(GetStartedButton)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const BottomGetStartedButtonContainer = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 6px;
    position: fixed;
    bottom: 20px;
    width: 100%;
  }
`

export const BottomGetStartedButton = styled(GetStartedButton)`
  margin-top: 10px;
  margin-bottom: 50px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 0 auto;
    width: 90%;
  }
`

export const StyledSeparator = styled(Separator)`
  margin: 30px auto;
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${style(theme => theme.colors.stoneLight)};
  margin: 20px auto 20px;
  width: 200px;
`

export const AcornsLogo = styled.img`
  display: block;
  margin: 0 auto;
  width: 108px;
`

export const SpendPhoneImageContainer = styled.div`
  margin-top: 80px;
  overflow: hidden;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-top: 40px;
  }
`

export const SpendPhoneImage = styled.img`
  display: block;
  height: 410px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    height: 330px;
  }
`

export const MobileContentContainer = styled.div`
  padding-bottom: 1px;
  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const DesktopContentContainer = styled.div`
  margin-top: 50px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const VideoPlayButtonContainer = styled.div`
  cursor: pointer;
  margin: 30px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f5f5f5;
  border-radius: 30px;
  padding: 2px 10px;
  max-width: 180px;
`

export const VideoPlayButtonTitle = styled.div`
  display: inline-block;
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`
export const VideoPlayButton = styled.img`
  display: inline-block;
  margin-top: 3px;
  width: 42px;
`

// Details & Detail Item styles
export const DetailsContainer = styled.div`
  margin: 50px 30px 0;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const DetailItemContainer = styled.div`
  align-items: center;
  display: flex;
  height: 38px;
  margin-bottom: 24px;
`

export const DetailItemImage = styled.img`
  width: 36px;
`

export const DetailItemText = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  margin-left: 17px;
`

// Card Overview styles
export const OverviewContainer = styled.div`
  margin: 20px 30px 0;
`
export const OverviewHeader = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
`

export const OverviewParagraph = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  line-height: 22px;
  margin-top: 6px;
  text-align: center;
`

export const OverviewPricing = styled.div`
  color: ${style(theme => theme.colors.green)}
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  margin-top: 6px;
  text-align: center;
`

// Accordions styles
export const AccordionsContainer = styled.div`
  margin: 0;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const AccordionsTitle = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  line-height: 16px;
  margin: 50px 30px 0;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const StyledTopAccordion = styled(Accordion)`
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  margin-top: 20px;

  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    border: 1px solid #f5f5f5;
    border-radius: 10px 10px 0 0;
    max-width: 450px;
    margin: 20px 15% 0;
  }

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 20px 0 0;
  }
`

export const StyledBottomAccordion = styled(Accordion)`
  border-bottom: 1px solid #f5f5f5;

  @media (min-width: ${style(theme => theme.breakpoints.sm)}px) {
    border-left: 1px solid #f5f5f5;
    border-right: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    border-radius: 0 0 10px 10px;
    max-width: 450px;
    margin: 0 15%;
  }

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 0;
  }
`

// Accordion styles
export const AccordionWrapper = styled.div`
  cursor: pointer;
  padding: 0 30px;

  & .ReactCollapse--collapse {
    transition: height 250ms;
  }
`

export const AccordionTrigger = styled.div`
  align-items: center;
  display: flex;
  height: 76px;
`

export const AccordionHeaders = styled.div`
  flex-grow: 1;
  margin-left: 16px;
`

export const AccordionHeadersIcon = styled.img`
  width: 36px;
`

export const AccordionHeader = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`

export const AccordionSubheader = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  height: 16px;
  line-height: 16px;
`

export const CollapseContentContainer = styled.div`
  padding-bottom: 30px;
`

// Accordion Content styles
export const AccordionContentContainer = styled.div`
  margin-left: 52px;
  padding: 10px 0;
`

export const AccordionContentHeader = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`

export const AccordionContentText = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 14px;
  line-height: 22px;
`

// This is so that we're able to wrap our Accordion component in our withClickTrack
export const AccordionClickTracker = styled.div``

// Security Notice styles
export const SecurityNoticeContainer = styled.div`
  margin-top: 30px;
  padding-bottom: 50px;
  padding-left: 20%;
  padding-right: 20%;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    padding-left: 15%;
    padding-right: 15%;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-left: 33px;
    padding-right: 33px;
    padding-bottom: 100px;
  }
`

export const SecurityNoticeText = styled.div`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  line-height: 1.67;
  margin: 0 auto;
  max-width: 450px;
  text-align: center;
`
